import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Capacitor } from '@capacitor/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';
import { LoggingService } from '@ld.consumer-portal/utils';

@Component({
  selector: 'ld-force-update-modal',
  imports: [BaseModalComponent, TranslocoDirective, MatProgressSpinner],
  templateUrl: './force-update-modal.component.html',
  styleUrl: './force-update-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForceUpdateModalComponent {
  private readonly loggingService = inject(LoggingService);
  title = input<string>('Update Required');

  message = input<string>('A new version of the app is available. Please update to continue.');

  currentVersion = input<string>('');

  minimumVersion = input<string>('');

  updateButtonText = input<string>('Update Now');

  isLoading = signal(false);

  update = output<void>();

  protected async onUpdate(): Promise<void> {
    this.isLoading.set(true);
    this.update.emit();
    await this.openAppStore();
  }

  private async openAppStore(): Promise<void> {
    const iosAppStoreUrl = 'https://apps.apple.com/app/loandepot/id6738976507';
    const androidPlayStoreUrl = 'https://play.google.com/store/apps/details?id=com.loandepot.loandepotmobile';

    const isIOS = Capacitor.getPlatform() === 'ios';
    const url = isIOS ? iosAppStoreUrl : androidPlayStoreUrl;

    try {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
    } catch (err) {
      this.loggingService.logException(err, 'ForceUpdateModal: Failed to open app store');
      window.open(url, '_blank');
    } finally {
      this.isLoading.set(false);
    }
  }
}
